<template>
	<div class="footer">
		<div class="footer-wrap">
			<p>© 2026 阆中分类信息网 版权所有 | <a href="https://beian.miit.gov.cn/">蜀ICP备2026028209号</a></p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer'
	}
</script>

<style lang="scss" scoped>
	.footer {
		background: #f5f5f5;
		padding: 20px 0;
		text-align: center;
		color: #666;
		margin-top: 30px;
	}
</style>